/* ═══════════════════════════════════════════════════════════════════════
   KITSTERS - ALL-COLLECTIONS INDEX  (/collections)
   ═══════════════════════════════════════════════════════════════════════

   Two jobs, both progressive enhancements: staggered scroll reveal, and
   a smooth jump-link scroll that does not fight the sticky header.

   The reveal is opt-IN by design. The CSS only hides a card once THIS
   script has added `.kcl-anim` to the root, so a failed/blocked script
   leaves every card visible rather than leaving the page blank.

   Bound at `document.body`, not `document` (CLAUDE.md §10.35): a section
   is a sibling of the header/footer, so there is no single element that
   contains everything, and `document.classList` does not exist.
   ═══════════════════════════════════════════════════════════════════════ */
(function () {
  "use strict";

  var REDUCED =
    window.matchMedia &&
    window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  function initReveal(root) {
    var items = root.querySelectorAll("[data-kcl-reveal]");
    if (!items.length) return;
    if (REDUCED || !("IntersectionObserver" in window)) return;

    // Only now does the hidden state exist - see the CSS note above.
    root.classList.add("kcl-anim");

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add("is-in");
          io.unobserve(entry.target);
        });
      },
      { threshold: 0.15, rootMargin: "0px 0px -40px 0px" }
    );

    items.forEach(function (el) {
      io.observe(el);
    });
  }

  function initJumpLinks(root) {
    var links = root.querySelectorAll(".kcl-jump");
    if (!links.length) return;

    links.forEach(function (link) {
      link.addEventListener("click", function (event) {
        var id = link.getAttribute("href");
        if (!id || id.charAt(0) !== "#") return;

        var target = document.getElementById(id.slice(1));
        if (!target) return;

        event.preventDefault();
        target.scrollIntoView({
          behavior: REDUCED ? "auto" : "smooth",
          block: "start"
        });

        // Keep the URL shareable without letting the browser's own jump
        // undo the scroll-margin-top the CSS just applied.
        if (window.history && window.history.replaceState) {
          window.history.replaceState(null, "", id);
        }

        // Move keyboard focus to the band without re-scrolling: a plain
        // focus() cancels an in-flight smooth scroll and lands ~200px off
        // (CLAUDE.md §10.36).
        target.setAttribute("tabindex", "-1");
        try {
          target.focus({ preventScroll: true });
        } catch (e) {
          /* older Safari ignores the options object - skip focus rather
             than let it scroll the page a second time */
        }
      });
    });
  }

  function init() {
    var root = document.querySelector(".kcl");
    if (!root) return;
    initReveal(root);
    initJumpLinks(root);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
